import { IProductDetail } from '@/api/types/public';
import MemberTagOnly from '@/components/Product/MemberTag';
import { formatPriceNumberWithSymbol } from '@/utils/price';
import { useTranslations } from '@/i18n/use-translations';
import React from 'react';

interface MemberTagProps {
  userInfo: {
    member_level?: number;
    is_member?: number;
  } | null;
  priceInfo: {
    price: number;
    sell_price: number;
  };
  currency: {
    name: string;
    symbol?: string;
  };
  promotionType: string;
  product: IProductDetail;
  isWeb?: boolean;
}

const MemberTag: React.FC<MemberTagProps> = ({
  userInfo,
  priceInfo,
  currency,
  promotionType,
  product,
  isWeb = false,
}) => {
  const t = useTranslations('goodsDetail');
  if (promotionType !== 'member') return null;
  if (
    priceInfo.sell_price !== priceInfo.price &&
    userInfo?.member_level < 0 &&
    product[`discount_percent_v${userInfo.member_level}`] > 0
  ) {
    return null;
  }

  const savings = formatPriceNumberWithSymbol(
    (priceInfo.price - priceInfo.sell_price).toFixed(2),
    currency,
  );

  return (
    <div className={`${isWeb ? 'py-0' : 'py-[4px] pb-[6px]'}`}>
      <div className="flex items-center">
        <MemberTagOnly level={userInfo?.member_level || 0} />
        <span
          className={`${isWeb ? 'text-[#a9a9a9] whitespace-nowrap' : 'text-[#808080] text-11'}`}
          style={{
            fontSize: isWeb ? 'max(.7291666667vw, 11px)' : '',
          }}
        >
          {t('saveMoreThanNonMembers', { savings })}
        </span>
      </div>
    </div>
  );
};

export default MemberTag;
